import axios from './httpConfig.js'
//******************基本设置 -- 公司管理 ******************/
// 公司列表
export function GetCompanyList(param) {
	return axios.post('/admin/company/list', param)
}

// 新增公司
export function AddCompany(param) {
	return axios.post('/admin/company/add', param)
}

// 禁用公司
export function DisabledCompany(param) {
	return axios.post('/admin/company/disabled', param)
}

// 删除公司
export function DeleteCompany(param) {
	return axios.post('/admin/company/delete', param)
}

// 修改公司
export function EditCompany(param) {
	return axios.post('/admin/company/edit', param)
}


// ******************基本设置 -- 操作员管理 ******************/
// 操作员列表
export function GetOperatorList(param) {
	return axios.post('/admin/user/list', param)
}

// 操作员禁用
export function DisabledOperator(param) {
	return axios.post('/admin/user/disabled', param)
}

// 操作员删除
export function DeleteOperator(param) {
	return axios.post('/admin/user/delete', param)
}

// 操作员重置密码为123456
export function SetOperatorReset(param) {
	return axios.post('/admin/user/reset', param)
}

// 设置公司管理员
export function SetOperatorAdmin(param) {
	return axios.post('/admin/user/companyadmin', param)
}

// 设置超级管理员接口
export function SetOperatorSuperAdmin(param) {
	return axios.post('/admin/user/superadmin', param)
}

// 操作员新增
export function AddOperator(param) {
	return axios.post('/admin/user/add', param)
}

// 操作员 授权(授予角色)接口
export function AddRoleForOperator(param) {
	return axios.post('/admin/user/sort/add', param)
}

// 读取 操作员 已经获得 角色 接口
export function getRoleByOperator(param) {
	return axios.post('/admin/user/sort/list', param)
}

// 获取操作员详情接口接口
export function GetOperatorInfo(param) {
	return axios.post('/admin/user/read/info', param)
}

// 操作员删除单点登录绑定接口
export function DeleteOperatorSso(param) {
	return axios.post('/admin/user/sso/delete', param)
}

// 操作员唯一登录
export function SetOnlyOnline(param) {
	return axios.post('/admin/user/set/onlyonline', param)
}


// ******************基本设置 -- 业务员管理******************/
// 业务员列表
export function GetSalesmanList(param) {
	return axios.post('/admin/salesman/list', param)
}

// 新增业务员
export function AddSalesman(param) {
	return axios.post('/admin/salesman/add', param)
}
// 删除业务员
export function DeleteSalesman(param) {
	return axios.post('/admin/salesman/delete', param)
}
// 修改业务员
export function EditSalesman(param) {
	return axios.post('/admin/salesman/edit', param)
}

// 禁用业务员
export function DisabledSalesman(param) {
	return axios.post('/admin/salesman/disabled', param)
} 
// 离职业务员
export function QuitSalesman(param) {
	return axios.post('/admin/salesman/quit', param)
}


// ******************基本设置 -- 角色权限配置******************/
// 角色列表
export function GetRoleList(param) {
	return axios.post('/admin/sort/list', param)
}
// 新增角色
export function AddRole(param) {
	return axios.post('/admin/sort/add', param)
}
// 删除角色
export function DeleteRole(param) {
	return axios.post('/admin/sort/delete', param)
}
// 修改角色
export function EditRole(param) {
	return axios.post('/admin/sort/edit', param)
}
// 禁用角色
export function DisabledRole(param) {
	return axios.post('/admin/sort/disabled', param)
} 
// 给角色添加操作员
export function AddOperateInRole(param) {
	return axios.post('/admin/sort/user/add', param)
} 
// 读取角色下所有的操作员
export function getOperateInRole(param) {
	return axios.post('/admin/sort/user/list', param)
} 
// 删除角色下的操作员
export function DeleteOperateInRole(param) {
	return axios.post('/admin/sort/user/delete', param)
} 